import React from 'react'

const Form: React.FC<{ id: string }> = ({ id }) => (
  <div
    id={id}
    {...{ 'data-name': 'SelfAsserted' }}
    dangerouslySetInnerHTML={{
      __html: `
<div class="buttons">
</div>
<div class="intro">
  <p>Please provide the following details.</p>
</div>
<form id="attributeVerification" action="JavaScript:void(0);">
  <div id="passwordEntryMismatch" class="error pageLevel" style="display: none;" aria-hidden="true">The password entry fields do not match. Please enter the same password in both fields and try again.</div>
  <div id="requiredFieldMissing" class="error pageLevel" style="display: none;" aria-hidden="true">A required field is missing. Please fill out all required fields and try again.</div>
  <div id="fieldIncorrect" class="error pageLevel" style="display: none;" aria-hidden="true">One or more fields are filled out incorrectly. Please check your entries and try again.</div>
  <div id="claimVerificationServerError" class="error pageLevel" style="display: none;" aria-hidden="true"></div>
  <div id="attributeList" class="attr">
    <ul>
        <li class="CheckboxMultiSelect"><div class="attrEntry"><label id="emailAddressAlreadyInUseContinueWithPasswordReset_label" for="emailAddressAlreadyInUseContinueWithPasswordReset">Continuation preference</label><div class="error itemLevel" role="alert"></div><input id="emailAddressAlreadyInUseContinueWithPasswordReset_true" name="emailAddressAlreadyInUseContinueWithPasswordReset" type="checkbox" aria-labelledby="emailAddressAlreadyInUseContinueWithPasswordReset_label emailAddressAlreadyInUseContinueWithPasswordReset_true_option" value="true" autofocus="autofocus"><label id="true_option" for="emailAddressAlreadyInUseContinueWithPasswordReset_true">Continue with password reset</label><a class="helpLink tiny" href="javascript:void(0)">What is this?</a></div></li>
    </ul>
  </div>
  <div class="buttons">
    <button id="continue" type="submit" form="attributeVerification" aria-disabled="false" aria-label="Continue">Continue</button><button id="cancel" aria-label="Cancel" formnovalidate="">Cancel</button>
  </div>

  <div class="verifying-modal">
    <div id="verifying_blurb"></div>
  </div>
</form>
`,
    }}
  ></div>
)

export default Form
